import React, {useMemo} from 'react';
import classNames from 'classnames';
import {sanitizeUserHtml} from '../../helpers/sanitizeHtml';

/**
 * Vykreslí formátovanou legendu tématu přesně tak, jak byla vytvořena ve WYSIWYG editoru –
 * HTML se pouze sanitizuje, jinak se do jeho struktury nezasahuje.
 */
export const FormattedLegend: React.FC<{html: string; className?: string}> = ({html, className}) => {
    const safeHtml = useMemo(() => sanitizeUserHtml(html), [html]);

    return <div className={classNames('formatted-text-value legend-formatted-text', className)} dangerouslySetInnerHTML={{__html: safeHtml}} />;
};

FormattedLegend.displayName = 'FormattedLegend';
